module.exports = __webpack_public_path__ + "static/key-yuppiepsych-020d2bd885331614af42a49fe2a719db.webp";